<template>
    <div>

    </div>
</template>
<style>
</style>
<script>
  export default {
  name: 'AndroidButton',
  data() {
    return {
        lastHistoryPosition: false
    }
  },
  mounted () {
    this.lastHistoryPosition = history.state?.position ?? 0;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('showConversation')
    })
  },
  beforeRouteLeave (/* to, from */) {
    const currentPosition = history.state?.position ?? 0;
    if(currentPosition >= this.lastHistoryPosition) { return true } // not going back
    if(!this.$root.$refs.conversation.close()) {
      return false
    }
    this.$store.commit('closeConversation')
  }
}
</script>
